import script from "./homeButtom.vue?vue&type=script&setup=true&lang=js"
export * from "./homeButtom.vue?vue&type=script&setup=true&lang=js"

import "./homeButtom.vue?vue&type=style&index=0&id=8d9b4400&scoped=true&lang=less"

import exportComponent from "/data/opt/jenkins/workspace/prod/建博会大药房/dms-web-prod/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d9b4400"]])

export default __exports__